export default "__VITE_ASSET__1QX0V1GB__"